import "./styles.less";

import { Checkbox, Col, Row, Select } from "antd";

import React, { useContext } from "react";
import { usePropertyType } from "./PropertyType.hook";
import { useTheme } from "../../../Styles/ThemeHook";
import { IC_Collapse } from "shared-components/Components/Collapse/web";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { firstLetterToUppercase } from "src/utils/Functions";
import { BoxesContainer } from "../BoxesContainer/web";

const { Option } = Select;

export const PropertyType = ({ collapsable = false, borderRadio=false, ...props }) => {
	const { theme } = useTheme();
	const { translations } = useContext(ConfigStateContext);
	const {
		show,
		inputType,
		label,
		data: { options, onChange, value = [] },
	} = usePropertyType(props);
	let filter = null;
	const {
		showUpTo = null
	  } = props;

	if (!show) return null;

	const handleChange = checked => {
		const res = options.filter(o => checked.includes(o.value));
		onChange(res);
	};

	const handleBoxChange = pressedOption => {
		let temp = [];
		if(value.includes(pressedOption.value)) {
		  temp = value.filter(o => o !== pressedOption.value);
		} else {
		  temp = [...value, pressedOption.value];
		}
	
		const res = options.filter(o => temp.includes(o.value));
		setTimeout(() => {
		  onChange(res);
		}, 10);
	}

	const isSelected = (opt) => {
		if (value.includes(opt.value)) return true;
		else return false;
	};

	if (inputType == "checkboxselect") {
		filter = (
			<Checkbox.Group value={value} onChange={handleChange}>
				<Row gutter={[0, theme.spacing.lgSpacing]}>
					{options?.map(o => (
						<Col span={24} key={`key_${o.value}_propertyType`}>
							<Checkbox value={o.value}>{o.text}</Checkbox>
						</Col>
					))}
				</Row>
			</Checkbox.Group>
		);
	} else if (inputType == "boxes") {
		filter = (
			<>
				<BoxesContainer
					options={options}
					selectedValues={value}
					isItemActive={(option, index) => isSelected(option, index)}
					onItemClick={handleBoxChange}
					showUpTo={showUpTo}
				/>

				<hr style={{width:"100%", border:'none', borderTop:'1px solid rgba(0,0,0,.06)', margin:'24px 0'}} />
			</>
		);
	}
	else {
		filter = (
			<Select
				value={value}
				mode={"multiple"}
				showArrow
				optionFilterProp="children"
				onChange={handleChange}
				style={{ width: "100%" }}
				placeholder={"Seleccione un Tipo de Propiedad"}>
				{options?.map(o => (
					<Option key={`name_${o.value}`} value={o.value}>
						{o.text}
					</Option>
				))}
			</Select>
		);
	}

	return (
		<>
			<div className={`filter property-type-filter ${borderRadio ? 'filter-with-border' : ''}`}>
				{collapsable
					? <IC_Collapse label={firstLetterToUppercase(translations.property_type)} isActive={value.length >= 1} startOpen={value.length <= 0}>
						{filter}
					</IC_Collapse>
					:  <>
						{inputType === "boxes" && <h3 className="filter-title">{firstLetterToUppercase(translations.property_type)}</h3>}

						{filter}
					</>
				}
			</div>
			<style jsx global>{`
				.home-filters .property-type-filter .ant-select .ant-select-selector {
					text-overflow: ${value.length > 0 ? "ellipsis" : "unset"};
				}
			`}</style>
		</>
	);
};
